import { pipe, prop, props, filter, join, trim, applySpec, path } from 'ramda';
import moment from 'moment';

import {
  ID,
  STATUS,
  PUBLIC_ID,
  SUB_PATIENT,
  RECEIVER,
  INSTITUTION,
  FIRST_NAME,
  LAST_NAME,
  META,
  CREATED,
  REPORT_STATUS,
  ALL,
} from 'store/reports';
import { CONTACT_NAMES } from 'store/patients';

export const statuses = [{ id: ALL, title: 'Alle' }, ...REPORT_STATUS];

export const tableHead = [
  {
    id: PUBLIC_ID,
    content: 'Bericht-Nr.',
    width: '15%',
  },
  {
    id: 'patientName',
    content: 'Patient',
    width: '24%',
    withoutSort: true,
  },
  {
    id: 'receiverName',
    content: 'Empfänger',
    width: '31%',
    withoutSort: true,
  },
  {
    id: 'meta.created',
    content: 'Datum',
    width: '15%',
  },
  {
    id: STATUS,
    content: 'Status',
    width: '15%',
  },
];

const joinName = (feature) => pipe(prop(feature), props([FIRST_NAME, LAST_NAME]), filter(Boolean), join(' '), trim);

const getReceiver = (report) => {
  const [institution = '', firstname = '', lastname = ''] = props([INSTITUTION, FIRST_NAME, LAST_NAME], prop(RECEIVER, report));

  if (institution) return institution;
  return [firstname, lastname].join(' ');
};

export const handleFields = applySpec({
  id: prop(ID),
  publicId: prop(PUBLIC_ID),
  patientName: joinName(SUB_PATIENT),
  receiverName: getReceiver,
  date: pipe(path([META, CREATED]), (date) => moment(date).format('DD.MM.YYYY')),
  status: prop(STATUS),
});

export const CONTACT_LIST = [{ id: ALL, title: 'Alle' }, ...CONTACT_NAMES];
